import React from "react";
import { MiModalConfirm } from "@miview/components";
import { useTheme } from "@mui/material";

const DeleteRedTagModal = (props) => {
  const { open, onClose, handleDelete } = props;

  const theme = useTheme();

  return (
    <MiModalConfirm
      titleColor={theme.palette.primary.red}
      title={"Confirm Delete"}
      open={open}
      description={
        "Are you sure you want to delete all information related to this Red Tag issue?"
      }
      handlePositive={handleDelete}
      handleNegative={onClose}
    ></MiModalConfirm>
  );
};

export default DeleteRedTagModal;
